<template>
	<v-container>
		<v-card class="shadowCard">
      <v-subheader>Resultados EXCI</v-subheader>
      <v-card-text v-if="verExci">
        <div class="row justify-content-md-center">
  				<iframe :src="url" width="100%" height="500px"></iframe>
        </div>
      </v-card-text>
    </v-card>
    
    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>
  </v-container>
</template>
<script>
	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'
	import Avataaars  from 'vuejs-avataaars'
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const  base64 = require('base-64');


  export default {
  	props:[
			'perfil'
	  ],

  	components:{
  		Alerta,
  		Avataaars,
  	},

    data: () => ({
    	respuestaAlerta: false,
      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
     	url:'',

     	verExci: false
    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS', 'getAvatar']),
    },

    created () {
    	const id_usuario = base64.encode( this.getUsuarioLMS.id )
      // Hacemos la petición
      this.$http.get('calificacion.exci/' + id_usuario).then( response => {
        // Guardamos los grupos
        this.url = response.body.RUTA_EXCI
        this.verExci = true
      }).catch( error =>{
        if( error.status == 400 || error.status == 500){
    			this.parametros.mensaje      = error.body.message
    			this.parametros.dialogError  = true 
    			this.parametros.color        = '#FF2C2C' 
    			this.respuestaAlerta         = true 
    		}
      }).finally(()=>{ this.cargar = false })
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'grabarDatosUsuario', 'grabarAvatar' ]),
    },
  }
</script>